import { themeVars } from '@instamenu/ui-vanilla-extract';

export type RadioButtonProps = {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  name: string;
};

const size = 26;

export function RadioButton({ checked, onChange, disabled, name }: RadioButtonProps) {
  const stroke = checked ? themeVars.color.brand : '#C5C4C4';
  return (
    <div style={{ position: 'relative', width: size, height: size }}>
      <input
        type="radio"
        checked={checked}
        onChange={() => onChange && onChange(!checked)}
        disabled={disabled}
        style={{
          cursor: 'pointer',
          height: size,
          opacity: 0,
          pointerEvents: disabled ? 'none' : undefined,
          position: 'absolute',
          width: size,
          zIndex: 1,
        }}
        name={name}
      />
      <svg
        width="26"
        height="26"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ position: 'absolute', top: 0, left: 0 }}
      >
        <circle cx="13" cy="13" r="12" stroke={stroke} strokeWidth="1" />
        {checked && <circle cx="13" cy="13" r="6" fill={stroke} />}
      </svg>
    </div>
  );
}
